import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { useTheme } from '@mui/material';
import { tertiaryHoverSx } from '../../styles/Global.style';

export const Delete = ({ sx }) => {
  const theme = useTheme();

  return (
    <DeleteOutlineIcon
      fontSize="medium"
      sx={{ ...tertiaryHoverSx(theme), ...sx }}
    />
  );
};
